import EditIcon from "@/assets/icons/EditIcon";
import FooterContactInfoForm from "@/pages/articles-pages/programmes/MultiStepForm/MicroSite/Templates/Shared/FooterContactInfoForm";
import { Paragraph } from "@/components/ui/Typography";
import { useMicroSiteContext } from "@/contexts/MicroSiteContext";
import { useState } from "react";
const Contact = () => {
    const { templatePayload, updateTemplatePayload } = useMicroSiteContext();
  const [isEditing, setIsEditing] = useState(false);
    const isEdit = new URLSearchParams(window.location.search).get('action') === 'edit';

        const handleSave = (formData: { address: string; email: string; }) => {
          setIsEditing(false);
          const updatedPayload = {
            ...templatePayload,
            footerSection: {
              ...templatePayload.footerSection,
                  footerAddress: formData.address,
              footerEmail: formData.email
          }
        };
          updateTemplatePayload(updatedPayload);
        };

  const PreviewComponent = () => {
    return (
      <div className="flex relative  flex-col w-full lg:py-4 gap-2  justify-center" style={{color: templatePayload.branding.textColorCode}}>   
          <div className="flex items-center gap-3" >
          <Paragraph>{templatePayload.footerSection.footerAddress}</Paragraph>
{isEdit && <EditIcon  className="cursor-pointer" onClick={() => setIsEditing(true)} />}
          </div>
          <Paragraph>{templatePayload.footerSection.footerEmail}</Paragraph>
      </div>
    )
  };


  return (
    <div>
      {isEditing ? <FooterContactInfoForm handleSave={handleSave} handleCancel={() => setIsEditing(false)} data={{ address: templatePayload.footerSection.footerAddress, email: templatePayload.footerSection.footerEmail }} /> : <PreviewComponent />}
    </div>
  )
}

export default Contact